import { useEffect, useState } from "react";
import { useQueryClient, QueryCache } from "@tanstack/react-query";
import { LimitReachedModal } from "./LimitReachedModal";

export function GlobalLimitHandler() {
  const [limitError, setLimitError] = useState<any>(null);
  const queryClient = useQueryClient();

  useEffect(() => {
    // Listen for query errors globally
    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      if (event.type === 'updated' && event.query.state.error) {
        const error = event.query.state.error as any;
        
        // Check if this is a limit_reached error
        if (error?.status === 403 && error?.errorCode === 'limit_reached') {
          console.log('🚫 [LIMIT-HANDLER] Limit reached error detected:', error.data);
          setLimitError(error.data);
        }
      }
    });

    // Also listen for mutation errors
    const mutationUnsubscribe = queryClient.getMutationCache().subscribe((event) => {
      if (event.type === 'updated' && event.mutation.state.error) {
        const error = event.mutation.state.error as any;
        
        // Check if this is a limit_reached error
        if (error?.status === 403 && error?.errorCode === 'limit_reached') {
          console.log('🚫 [LIMIT-HANDLER] Limit reached error detected (mutation):', error.data);
          setLimitError(error.data);
        }
      }
    });

    return () => {
      unsubscribe();
      mutationUnsubscribe();
    };
  }, [queryClient]);

  if (!limitError) {
    return null;
  }

  return (
    <LimitReachedModal
      open={!!limitError}
      onOpenChange={(open) => {
        if (!open) setLimitError(null);
      }}
      limitType={limitError.resourceType}
      currentUsage={limitError.currentUsage}
      limit={limitError.limit}
      isTrial={limitError.isTrial || false}
      message={limitError.message}
    />
  );
}
